import React,{useState, useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';
import CommonTooltip from '../../../../../../../../../component/common/CommonTooltip';
const AttributeListTable = (props) => {

    const { 
        index, 
        attribute,
        entities,
        validation_type,
        confirmation,
        data_type,
        max_validation_attempts
    } = props;

    let entitiesHtml = '';
    if( entities.length > 0 ){
        entitiesHtml = entities.map((entitie) =>
            <span className="badge badge-light-dark fs-7 fw-bold me-2 text-gray-600"  key={uuidv4()}>
                <span className="text-gray-600 fw-bold fs-6">
                    {entitie.value}
                </span>
            </span>
        )
    }

    const attributeDeleteOnClick = async (index) => {
        const attributeSwal = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won’t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
        if (attributeSwal.isConfirmed) {
            props.attributeDeleteOnClick(index)
        }
    }

    const handleDragStart = (e) => {
        e.dataTransfer.setData('text/plain', index);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const draggedIndex = parseInt(e.dataTransfer.getData('text/plain'), 10);
        props.onDragDrop(draggedIndex, index);
    };

    return (
        <>
            <tr
                draggable
                onDragStart={handleDragStart}
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}
                style={{
                    cursor: "move",
                }}
            >
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {attribute}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {entitiesHtml}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {validation_type.value}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {confirmation.value}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {data_type ? data_type.value: ''}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {max_validation_attempts}
                </td>
                <td className="d-flex float-end" >
                    <div
                        className='cursor-pointer me-3' 
                        onClick={(e) => { e.preventDefault(); props.attributeUpdateOnClick(index); }}
                        data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Edit"
                    >
                        <FontAwesomeIcon icon={faPen} className='text-primary fs-3' />
                    </div>
                    <div
                        className='cursor-pointer'
                        onClick={(e) => { e.preventDefault(); attributeDeleteOnClick(index);}}
                        data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Delete"
                    >
                        <FontAwesomeIcon icon={faTrash} className='text-danger fs-3' />
                    </div>
                </td>
            </tr>
            <CommonTooltip
                id="common_tooltip"
                style= {{ backgroundColor: "black", color: "white", fontSize:"14px" }}
                place="top"
                float={true}
            />
        </>
    )
}
const AttributeList = (props) => {
    const [viewAttributeList, setViewAttributeList] = useState([]);
    useEffect(() => {
        if (props.viewAttributeList) {
            setViewAttributeList(props.viewAttributeList);
        }
    }, [props.viewAttributeList]);
    const onDragDropHandler = (draggedIndex, targetIndex) => {
        const updatedList = [...viewAttributeList];
        const [draggedItem] = updatedList.splice(draggedIndex, 1);
        updatedList.splice(targetIndex, 0, draggedItem);
        updatedList.forEach((item, newIndex) => {
            item.index = newIndex;
        });
        setViewAttributeList(updatedList);
        props.attributeListOnDrop(updatedList)
    }
    let attributeListHtml = '';
    if( viewAttributeList.length > 0 ){
        attributeListHtml = viewAttributeList.map((attribute, i) =>
            <AttributeListTable
                key={i}
                index={i}
                attribute={attribute.attribute}
                entities={attribute.entities}
                validation_type={attribute.validation_type}
                confirmation={attribute.confirmation}
                data_type={attribute.data_type}
                max_validation_attempts={attribute.max_validation_attempts}
                attributeUpdateOnClick={props.attributeUpdateOnClick}
                attributeDeleteOnClick={props.attributeDeleteOnClick}
                onDragDrop={onDragDropHandler}
            />
        )
    }
    return (
        <>
            {viewAttributeList.length > 0 &&
                <>
                    <div className="separator border-gray-300 my-6"></div>
                    <div className="table-responsive">
                        <table className="table table-row-dashed align-middle gs-0 gy-4">
                            <thead className="border-gray-200 fs-5 fw-semibold bg-lighten">
                                <tr className='fs-7 fw-bold border-0 text-gray-400'>
                                    <th className="">Attribute</th>
                                    <th className="">Synonyms</th>
                                    <th className="">Validation Type</th>
                                    <th className="">Confirmation</th>
                                    <th className="">Data Type</th>
                                    <th className="">Max Attempts</th>
                                    <th className=""></th>
                                </tr>
                            </thead>
                            <tbody className="fw-6 fw-semibold text-gray-600">
                                {attributeListHtml}
                            </tbody>
                        </table>
                    </div>
                </>
            }
        </>
    )
}

export default AttributeList